import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="max-w-lg w-full text-center">
        <p className="text-amber-500 font-semibold mb-3">404</p>
        <h1 className="text-3xl font-bold text-white font-['Manrope'] mb-3">
          Page not found
        </h1>
        <p className="text-slate-400 mb-8">
          The page you are looking for does not exist or may have moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate("/dashboard")}
            className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold"
          >
            <Home className="h-4 w-4 mr-2" />
            Return to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
